import React from 'react';
import { Box, Tab, Tabs as MuiTabs } from '@mui/material';
import { ALL, BOOKMARK, RONE, SEARCH, TabsType } from 'components/Sidebar/types';

import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import { useTranslation } from 'react-i18next';

type FilterTabsProps = {
    activeTab: TabsType;
    handleTab: (val: TabsType) => void;
};

export const FilterTabs = ({ activeTab, handleTab }: FilterTabsProps) => {
    const { t } = useTranslation();

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        const value = newValue as TabsType;
        handleTab(value);
    };

    return (
        <>
            <Box className="sidebar-actions">
                <MuiTabs
                    className="sidebar-actions-tabs"
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab
                        label={t('web_app.tabs.all')}
                        iconPosition="start"
                        icon={<AccessTimeOutlinedIcon />}
                        value={ALL}
                    />
                    <Tab
                        label={t('web_app.tabs.bookmark')}
                        iconPosition="start"
                        icon={<BookmarkBorderOutlinedIcon />}
                        value={BOOKMARK}
                    />
                    <Tab
                        label="R-One"
                        iconPosition="start"
                        icon={<WorkOutlineOutlinedIcon />}
                        value={RONE}
                    />
                    <Tab iconPosition="start" icon={<SearchOutlinedIcon />} value={SEARCH} />
                </MuiTabs>
            </Box>
        </>
    );
};
